<div class="flex items-center justify-between w-full gap-6">
  <div class="flex items-center gap-2">
    @if (icon()) {
      <i class="pi {{ icon() }} {{ iconColor() }}"></i>
    }
    <span class="font-bold leading-none">
      {{ title() || (titleKey() | transloco: titleParams()) }}
    </span>

    @if (tooltip() || tooltipKey()) {
      <div class="flex items-center">
        <app-directus-tooltip
          tooltipStyleClass="tooltip-bg-second-level"
          [tooltip]="tooltip()"
          [tooltipKey]="tooltip() ? '' : tooltipKey()!"
        ></app-directus-tooltip>
      </div>
    }
  </div>

  <ng-content />
</div>
